import React from "react";

import {
    Modal,
    ModalBody,
    FormGroup,
    Label,
    ModalFooter,
    Button,
    Row, Col,
} from "reactstrap";

import ReactTable from "react-table-legacy";

import { Link } from 'react-router-dom';

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import Format from '../../common/Format';
import InputText from '../FormParts/InputText';
import CopyToClipWithSpan from '../FormParts/CopyToClipWithSpan';
import WithRole from '../FormParts/ButtonWithRole';

export default class SupplierSelectPopup extends React.Component {
    default_column = [
        { Header: '仕入先ID', accessor: 'SUPPLIER__supplier_natural_id', headerClassName: "text-center", className: "text-left text-top" },
        { Header: '仕入先名', accessor: 'SUPPLIER__supplier_name', headerClassName: "text-center", className: "text-left text-top", width:190,minWidth:50 },
        { Header: '電話番号1', accessor: 'SUPPLIER__supplier_tel', headerClassName: "text-center", className: "text-left text-top", width:190,minWidth:50 },
        { Header: '電話番号2', accessor: 'SUPPLIER__supplier_tel2', headerClassName: "text-center", className: "text-left text-top", width:190,minWidth:50 },
        // { Header: 'FAX番号', accessor: 'supplier_supplier_fax', headerClassName: "text-center", className: "text-center" },
        { Header: 'アクション', accessor: 'action', headerClassName: "text-center", className: "text-center" },
    ];
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: [],
            column: this.default_column,
            searchData:{
                values:{},
                errors:{},
                requiredData:{}
            },
            pageIndex:0
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.search = this.search.bind(this);
        this.clickSelectButton = this.clickSelectButton.bind(this);
        this.validateCallback = this.validateCallback.bind(this)
    }

    search() {
        var url = '/api/supplier';
        const params = {
            supplier_name : this.state.searchData.values.supplier_name,
            supplier_tel : this.state.searchData.values.supplier_tel,
            show_delete_data : '0'
        };
        
        Request.get(url, params, res => {
            this.setState({
                data: this.dataMap(res.data)
            });
        })
    }

    dataMap(data) {
        return data.map((prop, key) => {
            return {
                id: key,
                SUPPLIER__supplier_natural_id: (<Link className="link" target="_blank" to={"/supplier/detail/" + prop.ulid} color="facebook">{prop.supplier_natural_id}</Link>),
                SUPPLIER__supplier_name: (<CopyToClipWithSpan value={prop.supplier_name} />),
                SUPPLIER__supplier_tel: (<CopyToClipWithSpan value={Format.phone_number(prop.supplier_tel)} />),
                SUPPLIER__supplier_tel2: (<CopyToClipWithSpan value={Format.phone_number(prop.supplier_tel2)} />),
                // supplier_supplier_fax: (<CopyToClipWithSpan value={Format.phone_number(prop.supplier_fax)} />),
                action: (<Button type="button" color="default" className="btn-sm" onClick={() => { this.clickSelectButton(prop); }}>選択</Button>)
            }
        });
    }

    validateCallback(newData, callback=()=>{}){
        this.setState({
            searchData:{
            ...newData,
          }
        }, ()=>callback())
      }

    clickSelectButton(prop) {
        if (this.props.supplierSelectedCallback) {
            this.props.supplierSelectedCallback(prop);
        }
        this.toggleModal();
    }

    show() {
        this.setState({ modal: true });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
        return (
            <Modal size="lg" isOpen={this.state.modal}>
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                        <i className="tim-icons icon-simple-remove"></i>
                    </button>
                    <span style={{width: "100%"}}>
                        <h5 className="modal-title float-left">仕入先検索</h5>
                        <div style={{marginRight: "35px", marginTop: "-2px"}}>
                        <ButtonWithTooltipWithRole
                            button_id={(this.props.view?"BTN_M3_04_04730":"BTN_M3_02_04570")}
                            class="btn btn-default btn-sm float-right text-right"
                            id="tmp"
                            icon="fas fa-plus"
                            link="/supplier/add"
                            label="追加"
                            message="仕入先を追加"
                            size="sm"
                            target="_blank"
                        />
                        </div>
                    </span>
                </div>
                <ModalBody>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label for="SUPPLIER__supplier_name" className="search-text-order">仕入先名：</Label>
                                <InputText
                                    label='仕入先名'
                                    validateCallback={this.validateCallback} 
                                    validateType='search'
                                    name='SUPPLIER__supplier_name'
                                    copy={false}
                                    enterCallback={()=>{
                                        this.setState({
                                            pageIndex:0
                                        })
                                        this.search()
                                    }}
                                    enterSearchFlag={true}
                                    rootData={this.state.searchData}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label for="SUPPLIER__supplier_tel" className="search-text-order">電話番号：</Label>
                                <InputText
                                    validateCallback={this.validateCallback} 
                                    validateType='search'
                                    name='SUPPLIER__supplier_tel'
                                    copy={false}
                                    enterCallback={()=>{
                                        this.setState({
                                            pageIndex:0
                                        })
                                        this.search()
                                    }}
                                    enterSearchFlag={true}
                                    rootData={this.state.searchData}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <ButtonWithTooltip
                                    onclick={()=>{
                                        this.setState({
                                            pageIndex:0
                                        })
                                        this.search()
                                    }}
                                    class="btn-search"
                                    id="tmp"
                                    icon="fas fa-search"
                                    label="検索"
                                    message="検索を開始します。"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <ReactTable
                            page={this.state.pageIndex}
                            onPageChange={(pageIndex)=>{
                                this.setState({
                                    pageIndex
                                })
                            }}
                            style={{ width: '100%' }}
                            data={this.state.data}
                            columns={this.state.column}
                            defaultPageSize={5}
                            filterable={false}
                            showPageSizeOptions={false}
                            showPaginationTop={true}
                            showPaginationBottom={true}
                            previousText="前へ"
                            nextText="次へ"
                            rowsText="件表示"
                            loadingText='読込中…'
                            noDataText='データが有りません。'
                            pageText=''
                            ofText='/'
                            className="-highlight primary-pagination"
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}
